import { system300, system900 } from 'Mui/styles/color';

/**
 * 依照類型建立 section
 * textbox === Froala 編輯器
 * - 101: 姓名
 * - 102: 電子信箱
 * - 103: 手機號碼
 * - 104: 其他加密個資
 * - 201: 單行文字
 * - 202: 多行文字
 * - 203: 網址
 * - 204: 發票模組 - 發票號碼
 * - 205: 發票模組 - 收據號碼
 * - 206: 發票模組 - 隨機碼
 * - 301: 文字選擇題
 * - 302: 圖片選擇題
 * - 303: 單層下拉式選單
 * - 304: 雙層下拉式選單
 * - 305: 文字選擇題 + textbox
 * - 306: 圖片選擇題 + textbox
 * - 307: 是非題 + textbox
 * - 308: 影片選擇題
 * - 311: 等級評分
 * - 401: 日期 (僅年月日)
 * - 501: 視覺介面 (純文字區塊、按鈕)
 * - 502: 內容區塊 textbox
 * - 600: 同意條款
 * - 601: 發票模組 - 收據輸入類型
 * - 602: 檔案上傳
 * - 701: 結果區塊
 * - 801: 問答小學堂 - 答題數據承載
 */

export const ENCRYPT_NAME_SECTION = 101;
export const ENCRYPT_EMAIL_SECTION = 102;
export const ENCRYPT_PHONE_NUM_SECTION = 103;
export const ENCRYPT_SECTION = 104;
export const INPUT_SINGLE_LINE_SECTION = 201;
export const INPUT_MULTI_LINE_SECTION = 202;
export const INPUT_HREF_SECTION = 203;
export const INPUT_INVOICE_NUMBER = 204;
export const INPUT_RECEIPT_NUMBER = 205;
export const INPUT_INVOICE_RANDOM_NUMBER = 206;
export const TEXT_CHOICE_SECTION = 301;
export const IMG_CHOICE_SECTION = 302;
export const SINGLE_DROPDOWN_SECTION = 303;
export const DOUBLE_DROPDOWN_SECTION = 304;
export const TEXT_CHOICE_TEXTBOX_SECTION = 305;
export const IMG_CHOICE_TEXTBOX_SECTION = 306;
export const BOOL_CHOICE_TEXTBOX_SECTION = 307;
export const VIDEO_CHOICE_SECTION = 308;
export const RATING_SECTION = 311;
export const DATE_PICKER_SECTION = 401;
export const CONTENT_SECTION = 502;
export const TERMS_SECTION = 600;
export const FILE_UPLOAD_SECTION = 602;
export const RESULT_SECTION = 701;
export const QUIZ_RESULT_SECTION = 801;

const textInputTypes = [
    ENCRYPT_NAME_SECTION,
    ENCRYPT_EMAIL_SECTION,
    ENCRYPT_PHONE_NUM_SECTION,
    ENCRYPT_SECTION,
    INPUT_SINGLE_LINE_SECTION,
    INPUT_MULTI_LINE_SECTION,
    INPUT_HREF_SECTION,
    INPUT_RECEIPT_NUMBER,
    INPUT_INVOICE_RANDOM_NUMBER
];
export const isTextInputType = type => textInputTypes.includes(type);

export const mobileInputMode = {
    [ENCRYPT_EMAIL_SECTION]: 'email',
    [ENCRYPT_PHONE_NUM_SECTION]: 'tel'
};

/**
 * 選項類型
 * - NORMAL: 一般選項
 * - NORMAL_OTHER: 一般其他 + 單層下拉第一層其他 + 雙層下拉第二層其他
 * - TWO_LEVEL_OTHER: 雙層下拉第一層其他
 * - TWO_LEVEL_SECOND_OTHER: 雙層下拉第一層其他 附屬輸入框
 * - https://app.clickup.com/t/86ethhpvx
 */
export const OPTIONS_TYPE = {
    NORMAL: 1,
    NORMAL_OTHER: 2,
    TWO_LEVEL_OTHER: 3,
    TWO_LEVEL_SECOND_OTHER: 4
};

export const DEFAULT_COLOR = system300.color;
export const DEFAULT_LABEL_COLOR = system900.color;
